import React, { useEffect, useState } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import {colors} from '../components/Theme/WebTheme';
import Hero from "../components/Hero";
import Section from "../components/Section";
import Download from "../components/Download";

import { useSelector } from "react-redux";
import { useAnalytics } from '../common/useAnalytics';

const dashboardRoutes = [];

export default function LandingPage(props) {
  // Analytics hook
  const { logPageView, logPassengerHome } = useAnalytics();

  const auth = useSelector(state => state.auth);

  const { ...rest } = props;

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  // Analytics tracking for landing page
  useEffect(() => {
    // Track page view
    logPageView({
      title: 'Landing Page',
      userType: role || 'guest',
      pageType: 'landing_page'
    });
    
    // If user is passenger, log passenger home
    if (role === 'customer') {
      logPassengerHome();
    }
  }, [logPageView, logPassengerHome, role]);

  return (
    <div style={{backgroundColor:colors.WHITE,margin:'-8px'}}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Hero role={role}/>
      <Section role={role} color={colors}/>
      <Download />
      <HomeFooter />
    </div>
  );
}
